// src/Pages/Admin/Sesion/SesionDetails.js
import React from "react";

const formatearFecha = (fechaStr) => {
  if (!fechaStr) return "Fecha no disponible";
  try {
    return new Date(fechaStr).toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return fechaStr;
  }
};

const badgeDe = (estado) => {
  if (estado === "completada") return { clase: "sg-badge--completada", texto: "Completada" };
  if (estado === "en_proceso" || estado === "en_roceso") {
    return { clase: "sg-badge--proceso", texto: "En proceso" };
  }
  return { clase: "sg-badge--pendiente", texto: "Pendiente" };
};

const SesionDetails = ({ sesion }) => {
  if (!sesion) return null;

  const badge = badgeDe(sesion.estado);
  const cliente =
    sesion.usuario_asignado?.nombre ||
    sesion.usuario_asignado?.nombre ||
    sesion.usuario_asignado?.email ||
    null;

  return (
    <div className="sg-panel">
      <div className="sg-detail-top">
        <div>
          <h2 className="sg-detail-title">{sesion.nombre || "Sesión"}</h2>
          <p className="sg-detail-date">{formatearFecha(sesion.fecha)}</p>
          {sesion.descripcion && <p className="sg-detail-desc">{sesion.descripcion}</p>}
        </div>

        <div className="sg-detail-meta">
          <span className={`sg-badge ${badge.clase}`}>{badge.texto}</span>
          <p className="sg-detail-client">
            {cliente ? (
              <>
                <span className="sg-detail-client-label">Cliente</span>
                {cliente}
              </>
            ) : (
              "Sin cliente asignado"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SesionDetails;